import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { AcceptedConsentPdfUrlDto } from '@/features/dashboard/acceptedConsents/types/AcceptedConsentPdfUrlDto.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { AcceptedConsentListDto } from '@/features/dashboard/clients/types/AcceptedConsentListDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';

const acceptedConsentsApi = {
  getTableDefinition: (): Promise<TableDefinitionDto> =>
    fetchPrivateApi<TableDefinitionDto>(
      'GET',
      `accepted-consents/table-definition`,
    ),
  getAll: (
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<AcceptedConsentListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return fetchPrivateApi<PagedDto<AcceptedConsentListDto>>(
      'POST',
      `accepted-consents/all?${params.toString()}`,
      filterCriteria,
    );
  },
  getPdfUrl: (acceptedConsentId: string): Promise<AcceptedConsentPdfUrlDto> =>
    fetchPrivateApi<AcceptedConsentPdfUrlDto>(
      'GET',
      `accepted-consents/${acceptedConsentId}/pdf-url`,
    ),
  withdraw: (acceptedConsentId: string): Promise<void> =>
    fetchPrivateApi<void>(
      'POST',
      `accepted-consents/${acceptedConsentId}/withdraw`,
    ),
};

export default acceptedConsentsApi;
